import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Link, Text, useSitecore } from '@sitecore-content-sdk/nextjs';
const ComponentContent = (props)=>{
    const id = props.id;
    return /*#__PURE__*/ _jsx("div", {
        className: `component title ${props?.styles}`,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("div", {
                className: "field-title",
                children: props.children
            })
        })
    });
};
export const Default = (props)=>{
    const datasource = props.fields?.data?.datasource || props.fields?.data?.contextItem;
    const { page } = useSitecore();
    const text = datasource?.field?.jsonValue || {};
    const link = {
        value: {
            href: datasource?.url?.path,
            title: datasource?.field?.jsonValue?.value
        }
    };
    if (!page.mode.isNormal) {
        link.value.querystring = `sc_site=${datasource?.url?.siteName}`;
        if (!text?.value) {
            text.value = 'Title field';
            link.value.href = '#';
        }
    }
    return /*#__PURE__*/ _jsx(ComponentContent, {
        styles: props?.params?.styles,
        id: props?.params?.RenderingIdentifier,
        children: /*#__PURE__*/ _jsx(_Fragment, {
            children: page.mode.isEditing ? /*#__PURE__*/ _jsx(Text, {
                field: text
            }) : /*#__PURE__*/ _jsx(Link, {
                field: link,
                children: /*#__PURE__*/ _jsx(Text, {
                    field: text
                })
            })
        })
    });
};
